import { Box, Paper, Typography, Button } from "@mui/material";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

interface ErrorCardProps {
  title?: string;
  message: string;
  /** A secondary line under the message */
  detail?: string;
  onRetry?: () => void;
}

export default function ErrorCard({
  title = "Error",
  message,
  detail,
  onRetry,
}: ErrorCardProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: "12%",
        flex: 1,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 480, textAlign: "center" }}>
        <ErrorOutline color="error" sx={{ fontSize: 48, mb: 1.5 }} />
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography color="text.secondary">{message}</Typography>
        {detail && (
          <Typography
            color="text.secondary"
            sx={{ mt: 1, fontSize: "0.85rem" }}
            data-testid="error-card-detail"
          >
            {detail}
          </Typography>
        )}
        {onRetry && (
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
            sx={{ mt: 2 }}
          >
            Retry
          </Button>
        )}
      </Paper>
    </Box>
  );
}
